import Vue from 'vue'
import store from './store/index.js'
import router from './router'

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

import styles from './assets/style.sass'
import App from './App.vue'

import axios from 'axios'
import NProgress from 'vue-nprogress'

import {ValidationProvider, extend} from 'vee-validate'
import {NotifierBus} from './store/eventbusses.js'

axios.defaults.withCredentials = true
Vue.prototype.$http = axios
Vue.axios = axios

const nprogressoptions = {
  latencyThreshold: 100,
  router: false,
  http: true
}
Vue.use(NProgress, nprogressoptions)
const nprogress = new NProgress({ parent: '.nprogress-container' })

Vue.use(require('vue-moment'))
Vue.use(Buefy)

extend('secret', {
  validate: value => value === 'example',
  message: 'This is not the magic word'
})

Vue.component('ValidationProvider', ValidationProvider)
// Vue.use(VeeValidate, { inject: false, events: 'input|blur' })

// Enable devtools
Vue.config.devtools = true

const {state} = store

const app = new Vue({
  styles,
  store,
  router,
  nprogress,
  ...App
})
router.beforeEach((route, from, next) => {
  var requirements = []
  if (state.vaconfig.ServerURL === '') {
    requirements.push(store.dispatch('LoadVaConfig'))
  }
  if (state.security.UserId <= 0) {
    requirements.push(store.dispatch('security/Login'))
  }
  requirements.reduce((p, fn) => p.then(fn), Promise.resolve()).then(() => {
    if (!route.meta || !route.meta.permission || (state.security.UserId > 0 && state.security.Rules != null && state.security.Rules.includes(route.meta.permission))) {
      next()
    } else {
      NotifierBus.$emit('Notify', {type: 'danger', title: 'Security', message: '<div class="columns"><div class="column is-narrow"><i class="mdi mdi-account-lock mdi-24px"></i></div><div class="column"></div></div>Sorry, je hebt geen rechten tot<br> deze pagina!</div></div>', duration: 10000})
      next(false)
      nprogress.done(true)
    }
  })
})

app.$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js